var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-grid"},[_c('div',{staticClass:"page-grid__column page-grid__column--100"},[_c('BookingsOverviewFilters'),_c('BookingsOverviewTable'),_c('div',{staticClass:"align-middle"},[_c('BookingsPagination')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }